// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3wNL1","imageUploader":"EGiftCard_imageUploader__tRAVV"};